import { connect } from 'react-redux'

import TabInvoice from './units'

const mapStateToProps = state => ({
  projectInvoices: state.ProjectDetail.invoiceWithCreator.rows,
  upload: state.Upload,
})

export default connect(mapStateToProps)(TabInvoice)
